export enum TipoPolizaContable {
    Ingreso = 0,
    Egreso = 1,
    /**No usar este valor, ya que es un valor inválido */
    ExtraLibro = 2,
    Venta = 3,
}

/**Si el concepto es cargo o abono */
export enum TipoConceptoPolizaContable {
    Cargo,
    Abono
}

/**Indica el origen de una póliza contable */
export enum OrigenPolizaContable {
    /**Generada a partir de las guias pagadas a contado */
    Contado,

    /**Generada a partir de una factura de cobranza */
    Cobranza,

    /**Generada a partir de la factura de público general */
    PublicoGeneral,

    /**Generado a partir de las guias a crédito que no tienen factura */
    CreditoSinFactura,

    /**Generado a partir de un depósito a banco */
    DepositoBanco,

    /**Esta poliza es una cancelación de otra póliza */
    Cancelacion,

    /**Generada a partir de una facturación online */
    Online,

    /**Generada a partir de la factura de público general manual */
    PublicoGeneralManual,

    /**Generada a partir de la factura de público general automática */
    PublicoGeneralAutomatico,

    /**Generado a partir de la factura de nota de crédito */
    NotaDeCredito,

    /**Generado a partir de una factura automatica de persona moral */
    AutomaticaGuiaPersonaMoral,
    /**Generada a partir de un REP */
    Rep,

    /**Generado a partir de una entrega de ingresos a usuarios de ZE */
    EntregaIngresosZE,

    /**Generado a partir de una factura creada a partir de un conjunto de guías de prepago creada manualmente */
    PrePagoManual,

    /**Generado a partir de factura creada automáticamente al comprar el paquete de guías de PP */
    PrePagoAutomatica
}

export enum EstadoPolizaContable {
    /**Afectando saldos */
    Ejercico,
    ExtraLibro,
    Dia,
    Apertura,
    Cierre
}

/**Una poliza contable registrada en el sistema de contabilidad  */
export interface PolizaContable {
    IdRegistro: number;

    /**Identificador otorgado por el sistema de contabilidad */
    IdSistemaContabilidad: string;

    /**Fecha de creación de la póliza */
    FechaCreacion: Date | string;

    /**Fecha con la que se registra la póliza en el sistema de contabilidad, no necesariamente es lo mismo que la fecha de creación */
    FechaPoliza: Date | string;

    /**Si esta es una póliza de cancelación de otra póliza, este es el id de la poliza origal */
    IdPolizaCancelada: number | null;
    PolizaCancelada: PolizaContable;

    /**Descripción de la poliza */
    Concepto: string;

    /**Conceptos de la póliza */
    Conceptos: ConceptoPolizaContable[];

    /**Indica si la poliza es de ingreso/egreso/etc... */
    TipoPoliza: TipoPolizaContable;

    /**Estado de la poliza, este valor simplemente se pasa tal cual al sistma de contabilidad */
    EstadoPoliza: EstadoPolizaContable;

    /**Origen de la póliza */
    Origen: OrigenPolizaContable;

    /**En caso de que esta póliza provenga de una factura, es el id de la factura */
    IdFactura: number | null;

    /**En caso de que esta póliza provenga de un depósito a banco, es ese depósito */
    IdDepositoBanco: number | null;

    /**En caso de que esta póliza provenga de una entrega de ingresos a usuarios, es la entrega */
    IdEntregaIngresosAUsuario: number | null;

    /**Indica el usuario que cancelo esta factura */
    IdUsuarioCancelo: number | null;

    /**Fecha de la cancelación de la poliza */
    FechaCancelacion: Date | string | null;

    /**En caso de que esta póliza provenga de una poliza cancelada este es el id de la factura que fue cancelada para originar esta poliza */
    IdFacturaCancelacion: number | null;
}

/**Un concepto de una póliza contable, note que ademas de guardarse en el sistema de contabilidad se guarda también un espejo de todas las pólizas en la base de datos */
export interface ConceptoPolizaContable {
    IdRegistro: number;

    /**Id de la póliza padre */
    IdPolizaContable: number;
    PolizaContable: PolizaContable;

    /**Numero de cuenta a la que va dirigido */
    NoCuenta: string;
    /**Si es cargo/abono */
    Tipo: TipoConceptoPolizaContable;
    /**Importe del concepto */
    Importe: number;
    /**Descripción del concepto */
    Descripcion: string;
}

/**DTO de una póliza contable */
export interface PolizaContableDto extends PolizaContable {
    SerieFolioFactura: string;
    UUIDFactura: string;

    Conceptos: ConceptoPolizaContableDto[];

    Cargos: number;
    Abonos: number;

    NombreSucursal: string;

    /**Indica si la póliza no tienen ningún concepto */
    EstaVacia: boolean;

    NombreUsuarioCancelo: string;
    /**En caso de que sea una cancelación: este cmapo contendrá el id del sistema contabilidad de la factura original que originó esta cancelación */
    IdSistemaContabilidadPolizaOriginal: string;

    SerieFolioFacturaCancelacion: string;

}

/**DTO de un concepto de póliza contable */
export interface ConceptoPolizaContableDto extends ConceptoPolizaContable {
    Cargo: number | null;
    Abono: number | null;
}

export interface FiltroPolizaContable {
    FechaCreacionInicio?: Date | string | null;
    FechaCreacionFinal?: Date | string | null;
    Origen?: OrigenPolizaContable | null;
    EsLogistica: boolean| null;
}


// WEBPACK FOOTER //
// ./app/models/contabilidad.ts